<template>
  <Container type="card-full">
    <div slot="header">
      <el-button type="primary" v-if="type === 1 || type === 2" @click="save" :loading="btnLoading">保存</el-button>
    </div>
    <div class="main">
        <el-form :model="dpt" ref="ruleForm" label-position="right" class="mainfrom">
            <div class="from_input">
                <el-form-item label="部门名称" prop="dptname" verify>
                    <el-input v-model="dpt.dptname"  :maxlength="40" :disabled="type === 1 ? false:true"></el-input>
                </el-form-item>
            </div>
            <div class="from_input">
                <el-form-item label="部门标识" prop="dptsign" :verify="validateDptsign">
                    <el-input v-model="dpt.dptsign"  :maxlength="1" :disabled="type === 1 ? false:true"></el-input>
                    <span  style="color:blue">（ 1位，用于项目编号生成）</span>
                </el-form-item>
            </div>
            <div class="from_input">
                <el-form-item label="区域简称" prop="dptcode" verify>
                    <el-input v-model="dpt.dptcode"  :maxlength="2" :disabled="type === 1 ? false:true"></el-input>
                    <span  style="color:blue">（2位，用于协议编号生成）</span>
                </el-form-item>
            </div>
            <div class="from_input">
                <el-form-item label="所在区域 " prop="dptregionid" verify>
                    <el-select v-model="dpt.dptregionid" placeholder="请选择"  :disabled="type === 1 ? false:true">
                        <el-option v-for="item in dptareaList" :key="item.dptareaid" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <span style="color:blue">（用于公告发布区域）</span>
                </el-form-item>
            </div>
            <div class="from_input">
                <el-form-item label="地址">
                    <el-input v-model="dpt.dptaddress"  :maxlength="128" :disabled="type === 1 ? false:true"></el-input>
                </el-form-item>
            </div>
            <div class="from_input">
                <el-form-item label="联系人">
                    <el-input v-model="dpt.dptcontact"  :maxlength="10" :disabled="type === 1 ? false:true"></el-input>
                </el-form-item>
            </div>
            <div class="from_input">
                <el-form-item label="电话">
                    <el-input v-model="dpt.dpttel"  :maxlength="20" :disabled="type === 1 ? false:true"></el-input>
                </el-form-item>
            </div>
            <div class="from_input">
                <el-form-item label="传真">
                    <el-input v-model="dpt.dptfax"  :maxlength="20" :disabled="type === 1 ? false:true"></el-input>
                </el-form-item>
            </div>
            <div class="from_input">
                <el-form-item label="邮箱">
                    <el-input v-model="dpt.dptemail"  :maxlength="40" :disabled="type === 1 ? false:true"></el-input>
                </el-form-item>
            </div>
            <div class="from_input">
                <el-form-item label="分支机构  " prop="dptbranchfalg" verify>
                    <!-- <el-input v-model="dpt.dptbranchfalg"  :maxlength="11" :disabled="type === 1 ? false:true"></el-input> -->
                    
                    <el-radio-group v-model="dpt.dptbranchfalg" class="value" style="margin-top:14px" :disabled="type === 1 ? false:true">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <div v-if="+dpt.dptbranchfalg === 1">
                <div class="from_input">
                    <el-form-item label="机构全称" prop="dptfullname" verify>
                        <el-input v-model="dpt.dptfullname"  :maxlength="80" :disabled="type === 1 ? false:true"></el-input>
                    </el-form-item>
                </div>
                <div class="from_input">
                    <el-form-item label="信用代码">
                        <el-input v-model="dpt.dptuscc"  :maxlength="50" :disabled="type === 1 ? false:true"></el-input>
                    </el-form-item>
                </div>
                <div class="from_input">
                    <el-form-item label="开户银行">
                        <el-input v-model="dpt.dptbank"  :maxlength="128" :disabled="type === 1 ? false:true"></el-input>
                    </el-form-item>
                </div>
                <div class="from_input">
                    <el-form-item label="开户账号">
                        <el-input v-model="dpt.dptbanknumber"  :maxlength="50" :disabled="type === 1 ? false:true"></el-input>
                    </el-form-item>
                </div>
                <div class="from_input">
                    <el-form-item label="公章启用" prop="dptstampflag" verify >
                        <!-- <el-input v-model="dpt.dptstampflag"  :maxlength="11" :disabled="type === 1 ? false:true"></el-input> -->
                        <el-radio-group v-model="dpt.dptstampflag" class="value" style="margin-top:14px" :disabled="type === 1 ? false:true">
                            <el-radio :label="1">启用总公司公章</el-radio>
                            <el-radio :label="2">启用分支机构章</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <div class="from_input" v-if="+dpt.dptstampflag === 2">
                    <el-form-item label="上传公章  " prop="dptdepartmenturl" verify>
                        <!-- <el-input v-model="dpt.dptdepartmenturl"  :maxlength="11" :disabled="type === 1 ? false:true"></el-input> -->
                        <upload-pic-one @changed='setfile' :picUrl='dpt.dptdepartmenturl' folderName='web' text="选择图片"></upload-pic-one>
                    </el-form-item>
                </div>

            </div>
        </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import common from '@/mixin/common'
  import uploadPicOne from '../common/uploadPicOne'
  import _ from 'lodash'

  const SUCCESS = 1
  export default {
    name: "dptfrom",
    mixins: [common],
    data () {
      return {
          btnLoading:false,
          loading:false,
          dpt:{},
          dptareaList:[],//地区
          type:1
      }
    },
    async activated () {
        await this.init()
        await this.getdptInfo()
        await this.getDptareaList()
    },
    created(){
    },
    watch: {},
    filters: {},
    components: {uploadPicOne},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
        async init(){
            console.log('-------this.$route.params.dpt---------',this.$route.params.dpt);
            this.dpt = this.$route.params.dpt
            this.type = this.$route.params.type
        },
        async getDptareaList(){
            this.loading = true
            let res = await request({
                method: 'get',
                url: '/xtgl/dpt/getDptareaList',
                params: {cosid:this.$store.getters.loginUser.cosid}
            })
            this.dptareaList = res
            this.loading = false
        },
        async setfile (path) {
            this.$set(this.dpt, 'dptdepartmenturl', path.replace(this.uploadAddr, ''))
        },
        async save(){
            this.submitForm('ruleForm').then(async() => {
                this.loading = true
                this.dpt.dptcomid = this.$store.getters.loginUser.comid
                let res = await request({
                    method: 'post',
                    url: '/xtgl/dpt/savedpt',
                    data: this.dpt
                })
                if(res.issuccess === 1){
                    this.$message.success('保存成功')
                    await this.close()
                }
                this.loading = false
            }).catch(() => {})
        },
        //查找部门信息
        async getdptInfo(){
            this.loading = true
            if(!this.$route.params.dpt.dptid){
            return
            }
            let res = await request({
                method: 'get',
                url: '/xtgl/dpt/getdptInfo',
                params: {dptid:this.$route.params.dpt.dptid}
            })
            this.dpt = res
            this.loading = false
        },
        close () {
            this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'dptIndex'})
        },
        validateDptsign (rul, val, callback) {
            this.dpt.dptsign = _.trim(val)
            this.validateData('部门标识不能重复', 'dptrec', 'dptid', 'dptsign', val, callback)
        },
        validateData (msg, tablename, fieldid, checkfield, checkval, callback) {
            request({
                url: '/validate/validateData',
                method: "post",
                data: {tablename, fieldid, checkfield, checkval: this.dpt[checkfield], id: this.dpt.dptid}
                }).then(res => {
                console.log(res, 90900)
                res === SUCCESS ? callback(Error(msg)) : callback()
            })
        },
    }
  }
</script>


<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .from_select .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 520px;
    }
    .file {
      display: flex;
      flex-direction: column;
      width: 50%;
    }
    .alertmsg {
      color:red;
      width: 200px;
      line-height: 18px;
      word-break: break-all;
      word-wrap: break-word;
      overflow-y: hidden;
      font-size: 12px;
    }
  }
</style>
